





















































































































import { Component } from "vue-property-decorator";
import feather from "feather-icons";
import UserValidator from "@/resources/mixins/userValidator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "users-info-component",
})
export default class UsersInfoComponent extends mixins(
  UserValidator,
  NotificationEvent,
  Plans
) {
  PLAN = PLAN;
  feather = feather;
  usersOnline = null;
  dau = null;
  wau = null;
  mau = null;
  loading = false;
  externalDashboardUrl = null;
  isSuperAdminDashboard() {
    return this.$route.path === "/admin/dashboard";
  }
  mounted(): void {
    if (this.$route.path === "/admin/dashboard")
      this.$store.dispatch("DashboardStore/getSuperAdminMetricsAction", {
        callback: (data) => {
          this.usersOnline = data.usersOnline;
          this.dau = data.dau;
          this.wau = data.wau;
          this.mau = data.mau;
          this.externalDashboardUrl = data.externalDashboardUrl;
        },
      });
    else {
      let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
      if (!space) space = this.$store.getters["SpaceStore/getSpace"];
      this.$store.dispatch("DashboardStore/getSpaceAdminMetricsAction", {
        spaceId: space.id,
        callback: (data) => {
          this.usersOnline = data.usersOnline;
          this.dau = data.dau;
          this.wau = data.wau;
          this.mau = data.mau;
          this.externalDashboardUrl = data.externalDashboardUrl;
        },
      });
    }
  }
  async updateExternalDashboardUrl() {
    this.loading = true;
    const space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("SpaceStore/updateSpaceAction", {
      spaceId: space.id,
      payload: {
        externalDashboardUrl:
          this.externalDashboardUrl === "" ? null : this.externalDashboardUrl,
      },
      callback: () => {
        // do nothing
        this.loading = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.urlUpdate")
        );
      },
      callbackError: (error) => {
        // do nothing

        this.loading = false;
      },
    });
  }
}
